import {
    getHolidayList,
    addHoliday,
    updateHoliday,
    updateHolidayStatus,
    removeHolidays,
    getLeaveType,
    getAppliedLeaveList,
    AddAppliedLeave,
    updateAppliedLeave,
    removeLeave,
    updateLeaveStatus,
    getOwnLeaveCalenderList,
    getOwnReportLeaveList,
    AddReportPersonalDetails,
    updateReportLeaveList
} from '../../services/LeaveService';

import {
    LOADING_HOLIDAY,
    GET_HOLIDAY_LIST,
    GET_LEAVE_TYPE_LIST,
    GET_APPLIED_LEAVE_LIST,
    GET_OWN_LEAVE_CALENDER,
    GET_OWN_LEAVE_REPORT_CART
} from '../constants';

import * as utility from '../../utility/Utility';
import { globalLoadingAction } from '../actions/GlobalAction';


export function AddHolidayData(title, start_date, end_date, ListCallBack, history) {
    return (dispatch) => {
        addHoliday(title, start_date, end_date)
            .then((response) => {
                if (response.data.status == 200) {
                    ListCallBack();
                }
            })
            .catch((error) => {
                dispatch(globalLoadingAction(false));
            });
    };
}

export function updateHolidayData(id, title, start_date, end_date, status, ListCallBack, history) {
    return (dispatch) => {
        updateHoliday(id, title, start_date, end_date, status)
            .then((response) => {
                if (response.data.status == 200) {
                    ListCallBack();
                }
            })
            .catch((error) => {
                dispatch(globalLoadingAction(false));
            });
    };
}

export function getHolidayListData(title, page_no, per_page, history) {
    return (dispatch) => {
        getHolidayList(title, page_no, per_page)
            .then((response) => {
                if (response.data.status == 200) {
                    dispatch(getHolidayListAction(response.data));
                    dispatch(globalLoadingAction(false));
                }
            })
            .catch((error) => {
                dispatch(globalLoadingAction(false));
            });
    };
}

export function updateHolidayStatusData(item, callBack) {
    return (dispatch) => {
        updateHolidayStatus(item._id, item.status === 1 ? 0 : 1)
            .then((response) => {
                if (response.data.status == 200) {
                    callBack();
                    utility.showSuccess(response.data.msg);
                } else {
                    utility.showError(response.data.msg);
                }
            })
            .catch((error) => {
                //console.log(error);
                //utility.showError(response.data.msg);
                dispatch(globalLoadingAction(false));
            });
    };
}

export function removeHolidayData(id, callBack) {
    return (dispatch) => {
        removeHolidays(id)
            .then((response) => {
                if (response.data.status == 200) {
                    callBack();
                }
                dispatch(globalLoadingAction(false));
            })
            .catch((error) => {
                dispatch(globalLoadingAction(false));
            });
    };
}

export function getLeaveTypeData(history) {
    return (dispatch) => {
        getLeaveType()
            .then((response) => {
                if (response.data.status == 200) {
                    dispatch(getLeaveTypeAction(response.data));
                }
                dispatch(globalLoadingAction(false));
            })
            .catch((error) => {
                dispatch(globalLoadingAction(false));
            });
    };
}

export function getAppliedLeaveListData(page_no, per_page) {
    return (dispatch) => {
        getAppliedLeaveList(page_no, per_page)
            .then((response) => {
                if (response.data.status == 200) {
                    dispatch(getAppliedLeaveListAction(response.data));
                }
                dispatch(globalLoadingAction(false));
            })
            .catch((error) => {
                dispatch(globalLoadingAction(false));
            });
    };
}

export function AddAppliedLeaveData(leave_type, start_date, end_date, description, ListCallBack) {
    return (dispatch) => {
        AddAppliedLeave(leave_type, start_date, end_date, description)
            .then((response) => {
                if (response.data.status == 200) {
                    ListCallBack(true);
                } else {
                    utility.showError(response.data.msg);
                    ListCallBack(false);
                }
            })
            .catch((error) => {
                dispatch(globalLoadingAction(false));
            });
    };
}

export function AddReportPersonalDetailsData(leave_type, leave_date, leave_hours, ListCallBack) {
    return (dispatch) => {
        AddReportPersonalDetails(leave_type, leave_date, leave_hours)
            .then((response) => {
                if (response.data.status == 200) {
                    ListCallBack(true);
                } else {
                    utility.showError(response.data.msg);
                    ListCallBack(false);
                }
            })
            .catch((error) => {
                dispatch(globalLoadingAction(false));
            });
    };
}

export function updateAppliedLeaveData(id, leave_type, start_date, end_date, description, ListCallBack, history) {
    return (dispatch) => {
        updateAppliedLeave(id, leave_type, start_date, end_date, description)
            .then((response) => {
                if (response.data.status == 200) {
                    ListCallBack();
                    utility.showSuccess(response.data.msg);
                } else {
                    utility.showError(response.data.msg);
                    ListCallBack();
                }
            })
            .catch((error) => {
                dispatch(globalLoadingAction(false));
            });
    };
}

export function removeLeaveData(id, callBack) {
    return (dispatch) => {
        removeLeave(id)
            .then((response) => {
                if (response.data.status == 200) {
                    callBack();
                } else {
                    utility.showError(response.data.msg);
                }
                dispatch(globalLoadingAction(false));
            })
            .catch((error) => {
                dispatch(globalLoadingAction(false));
            });
    };
}


export function updateLeaveStatusData(id, status, callBack) {
    return (dispatch) => {
        updateLeaveStatus(id, status)
            .then((response) => {
                if (response.data.status == 200) {
                    callBack();
                    utility.showSuccess(response.data.msg);
                } else {
                    utility.showError(response.data.msg);
                }
            })
            .catch((error) => {
                dispatch(globalLoadingAction(false));
            });
    };
}

export function getOwnLeaveCalenderListData(userId, leave_type_id, props) {
    return (dispatch) => {
        getOwnLeaveCalenderList(userId, leave_type_id)
            .then((response) => {
                if (response.data.status == 200) {
                    dispatch(getOwnLeaveCalenderListAction(response.data));
                }
            })
            .catch((error) => {
                dispatch(globalLoadingAction(false));
            });
    };
}

export function getOwnReportLeaveListData(userId, filter_type, start_date, end_date, leave_type) {
    return (dispatch) => {
        getOwnReportLeaveList(userId, filter_type, start_date, end_date, leave_type)
            .then((response) => {
                if (response.data.status == 200) {
                    dispatch(getOwnReportLeaveListAction(response.data));
                }
                dispatch(globalLoadingAction(false));
            })
            .catch((error) => {
                dispatch(globalLoadingAction(false));
            });
    };
}

export function updateReportLeaveListData(userId, personal_details,callBack) {
    return (dispatch) => {
        updateReportLeaveList(userId, personal_details)
            .then((response) => {
                if (response.data.status == 200) {
                    callBack();
                }
                dispatch(globalLoadingAction(false));
            })
            .catch((error) => {
                dispatch(globalLoadingAction(false));
            });
    };
}

export function getHolidayListAction(data) {
    return {
        type: GET_HOLIDAY_LIST,
        payload: data,
    };
}
export function getLeaveTypeAction(data) {
    return {
        type: GET_LEAVE_TYPE_LIST,
        payload: data,
    };
}
export function getAppliedLeaveListAction(data) {
    return {
        type: GET_APPLIED_LEAVE_LIST,
        payload: data,
    };
}
export function getOwnLeaveCalenderListAction(data) {
    return {
        type: GET_OWN_LEAVE_CALENDER,
        payload: data,
    };
}
export function getOwnReportLeaveListAction(data) {
    return {
        type: GET_OWN_LEAVE_REPORT_CART,
        payload: data,
    };
}
export function loadingRoleAction(status) {
    return {
        type: LOADING_HOLIDAY,
        payload: status,
    };
}
